var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0015,
    cy: 16.7308,
    r: 15.6586,
    fill: "#05B226",
    stroke: "#05B226",
    strokeWidth: 1.84218
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8225 13.507C12.967 13.507 13.8949 12.5791 13.8949 11.4345C13.8949 10.2899 12.967 9.36206 11.8225 9.36206C10.6779 9.36206 9.75 10.2899 9.75 11.4345C9.75 12.5791 10.6779 13.507 11.8225 13.507Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1896 13.507C23.3342 13.507 24.2621 12.5791 24.2621 11.4345C24.2621 10.2899 23.3342 9.36206 22.1896 9.36206C21.0451 9.36206 20.1172 10.2899 20.1172 11.4345C20.1172 12.5791 21.0451 13.507 22.1896 13.507Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1882 16.7307C24.6795 16.7307 24.2733 17.1452 24.2095 17.6499C23.7578 21.222 20.7083 23.9843 17.0136 23.9843C13.3189 23.9843 10.2694 21.222 9.81764 17.6499C9.75382 17.1452 9.34757 16.7307 8.83886 16.7307H8.60859C8.09989 16.7307 7.68272 17.1443 7.73229 17.6506C8.19431 22.3695 12.1733 26.0568 17.0136 26.0568C21.8538 26.0568 25.8328 22.3695 26.2948 17.6506C26.3444 17.1443 25.9272 16.7307 25.4185 16.7307H25.1882Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodDark);
export default __webpack_public_path__ + "static/media/goodDark.feaaec1bb90b16e5faf2dee495e0c727.svg";
export { ForwardRef as ReactComponent };